import React from 'react';
import { ReferenceBrandType } from '@1po/1po-bff-fe-spec/generated/catalog/references/common/model/ReferenceBrandType';
import { ReactComponent as MotrioLogo } from 'assets/CarBrand/brand_motrio_mini.svg'; //NOSONAR
import { ReactComponent as RenativeLogo } from 'assets/CarBrand/brand_renative_reman_mini.svg'; //NOSONAR
import { ReactComponent as ValuePlusLogo } from 'assets/CarBrand/brand_value_plus_mini.svg'; //NOSONAR
import { checkRenative } from 'pages/UniversalProductsPage/ProductsPage/Product.utils'; //NOSONAR
import { Icon } from 'UI'; //NOSONAR

export const getReferenceLogo = (referenceBrand?: ReferenceBrandType, familyCode?: string, renative = false) => {
  const hasRenativeLogo = checkRenative(familyCode, renative);
  if (hasRenativeLogo) {
    return <Icon IconComponent={RenativeLogo} width={70} />;
  }
  switch (referenceBrand) {
    case 'MOTRIO':
      return <Icon IconComponent={MotrioLogo} width={70} />;
    case 'VALUE_PLUS':
      return <Icon IconComponent={ValuePlusLogo} width={70} />;
    case 'STANDARD_EXCHANGE':
      return <Icon IconComponent={RenativeLogo} width={70} />;
    default:
      return <></>;
  }
};
